module.exports = __webpack_public_path__ + "img/UNIFORM GREEN.76164d2.svg";